'use client';

import { c as _c } from "react/compiler-runtime";
import { Toast } from '@base-ui/react/toast';
import { css } from '@repo/pandacss/css';
import { ToastList } from './ToastList';
export function SnackbarProvider(t0) {
  const $ = _c(8);
  const {
    isPrimaryGoal: t1,
    children
  } = t0;
  const isPrimaryGoal = t1 === undefined ? false : t1;
  const t2 = isPrimaryGoal ? "0" : "[33.33%]";
  let t3;
  if ($[0] !== t2) {
    t3 = css({
      position: "fixed",
      bottom: "[calc(env(safe-area-inset-bottom) + 7rem)]",
      left: "0",
      right: {
        base: "0",
        lg: t2
      },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "2",
      zIndex: "[60]",
      pointerEvents: "none",
      px: "3"
    });
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ToastList />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t3) {
    t5 = <Toast.Portal><Toast.Viewport className={t3}>{t4}</Toast.Viewport></Toast.Portal>;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children || $[6] !== t5) {
    t6 = <Toast.Provider timeout={3000}>{children}{t5}</Toast.Provider>;
    $[5] = children;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}